const imageInput = document.getElementById("imageInput");
const canvas = document.getElementById("canvas");
const ctx = canvas.getContext("2d");
const downloadBtn = document.getElementById("downloadBtn");
// 新增：獲取相機按鈕元素
const cameraBtn = document.getElementById("cameraBtn");
// 新增：調整 canvas 大小的函數
function resizeCanvas() {
    const maxWidth = window.innerWidth * 0.8; // 設置為視窗寬度的 80%
    const maxHeight = window.innerHeight * 0.8; // 設置為視窗高度的 80%
    const ratio = Math.min(maxWidth / canvas.width, maxHeight / canvas.height);
    canvas.style.width = canvas.width * ratio + "px";
    canvas.style.height = canvas.height * ratio + "px";
}
let offsetX = 0;
let offsetY = 0;
let isDragging = false;
let startX, startY;
let scale = 1; // 新增：縮放因子
function drawImage() {
    const diameter = Math.min(canvas.width, canvas.height);
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.save();
    ctx.beginPath();
    ctx.arc(diameter / 2, diameter / 2, diameter / 2, 0, Math.PI * 2);
    ctx.clip();
    ctx.drawImage(img, offsetX, offsetY, diameter / scale, diameter / scale, 0, 0, diameter, diameter);
    ctx.restore();
}
// 新增：處理相機按鈕點擊事件
cameraBtn.addEventListener("click", function() {
    // 創建一個隱藏的 file input 元素
    const cameraInput = document.createElement("input");
    cameraInput.type = "file";
    cameraInput.accept = "image/*";
    cameraInput.capture = "camera";
    cameraInput.addEventListener("change", function(e) {
        handleImageSelection(e.target.files[0]);
    });
    cameraInput.click();
});
// 修改：將圖片處理邏輯抽取為單獨的函數
function handleImageSelection(file) {
    if (file) {
        const reader = new FileReader();
        reader.onload = function(e) {
            img = new Image();
            img.src = e.target.result;
            img.onload = function() {
                const diameter = Math.min(img.width, img.height);
                canvas.width = diameter;
                canvas.height = diameter;
                // 重置偏移量和縮放
                offsetX = (img.width - diameter) / 2;
                offsetY = (img.height - diameter) / 2;
                scale = 1; // 重置縮放
                drawImage();
                resizeCanvas();
            };
        };
        reader.readAsDataURL(file);
    } else alert("\u8ACB\u9078\u64C7\u4E00\u5F35\u5716\u7247");
}
// 修改：統一的事件處理函數
function handleStart(e) {
    isDragging = true;
    const rect = canvas.getBoundingClientRect();
    startX = ((e.clientX || e.touches[0].clientX) - rect.left) * (canvas.width / rect.width);
    startY = ((e.clientY || e.touches[0].clientY) - rect.top) * (canvas.height / rect.height);
}
function handleMove(e) {
    if (!isDragging) return;
    e.preventDefault(); // 防止滾動
    const rect = canvas.getBoundingClientRect();
    const x = ((e.clientX || e.touches[0].clientX) - rect.left) * (canvas.width / rect.width);
    const y = ((e.clientY || e.touches[0].clientY) - rect.top) * (canvas.height / rect.height);
    const dx = (x - startX) / scale;
    const dy = (y - startY) / scale;
    offsetX -= dx;
    offsetY -= dy;
    // 限制偏移量不超出圖片範圍
    const maxOffsetX = img.width - canvas.width / scale;
    const maxOffsetY = img.height - canvas.height / scale;
    offsetX = Math.max(0, Math.min(offsetX, maxOffsetX));
    offsetY = Math.max(0, Math.min(offsetY, maxOffsetY));
    drawImage();
    startX = x;
    startY = y;
}
function handleEnd() {
    isDragging = false;
}
// 修改：添加觸摸事件監聽器
canvas.addEventListener("mousedown", handleStart);
canvas.addEventListener("mousemove", handleMove);
canvas.addEventListener("mouseup", handleEnd);
canvas.addEventListener("mouseleave", handleEnd);
canvas.addEventListener("touchstart", handleStart);
canvas.addEventListener("touchmove", handleMove);
canvas.addEventListener("touchend", handleEnd);
canvas.addEventListener("touchcancel", handleEnd);
function handleWheel(e) {
    e.preventDefault(); // 防止頁面滾動
    const direction = e.deltaY < 0 ? "in" : "out";
    zoom(direction);
}
// 添加滾輪事件監聽器
canvas.addEventListener("wheel", handleWheel);
downloadBtn.addEventListener("click", function() {
    const link = document.createElement("a");
    link.href = canvas.toDataURL(); // 將 canvas 內容轉成圖片 URL
    link.download = "circle-cropped-image.png"; // 設定下載檔名
    link.click(); // 觸發下載
});
// 修改：更新現有的 imageInput 事件監聽器
imageInput.addEventListener("change", function() {
    handleImageSelection(this.files[0]);
});
// 獲取放大縮小按鈕
const zoomInBtn = document.getElementById("zoomInBtn");
const zoomOutBtn = document.getElementById("zoomOutBtn");
// 添加縮放函數
function zoom(direction) {
    const zoomFactor = direction === "in" ? 1.1 : 0.9;
    const newScale = Math.max(1, Math.min(scale * zoomFactor, 3)); // 限制縮放範圍在 1 到 3 之間
    // 計算畫布中心點
    const centerX = canvas.width / 2;
    const centerY = canvas.height / 2;
    // 調整偏移量以保持中心點不變
    offsetX = centerX - (centerX - offsetX) * (newScale / scale);
    offsetY = centerY - (centerY - offsetY) * (newScale / scale);
    scale = newScale;
    drawImage();
}
// 添加按鈕事件監聽器
zoomInBtn.addEventListener("click", ()=>zoom("in"));
zoomOutBtn.addEventListener("click", ()=>zoom("out"));

//# sourceMappingURL=index.db4f09f9.js.map
